export default [
	{
		path: '/pages/fileManage/fileManage',
		meta: { title: '资产地图' },
		name: '/pages/fileManage/fileManage',
		component: () => import('@/views/fileManage/fileManage.vue'),
	},
];
